import React from 'react';
import { InputTypeDropdown } from '.';
import { fetchTermYear } from '../services/options_service';

class InputDropdownStatus extends React.Component {
  state = {
    options: [],
  }

  componentDidMount() {
    this.fetchOptions();
  }

  fetchOptions = () => {
    fetchTermYear()
      .then((data) => {
        this.setState({
          options: data,
        });
      });
  }

  render() {
    const { ...rest } = this.props;
    const { options } = this.state;

    return (
      <InputTypeDropdown
        field="term_year"
        label="Etapa x Ano"
        options={options}
        {...rest}
      />
    );
  }
}

export default InputDropdownStatus;
